import { Card, CardContent, Box, Skeleton } from '@mui/material';
import { abyssColors } from '@/theme/colors';
import { useWindowSize } from '@/hooks/useWindowSize';
import { useMemo } from 'react';

type FileDisplaySkeletonProps = {
  cardHeight?: string;
  location?: string;
};

export const FileDisplaySkeleton = ({
  cardHeight = '80px',
  location = '',
}: FileDisplaySkeletonProps) => {
  const screenSize = useWindowSize();

  const dynamicCardHeight = useMemo(() => {
    const { width } = screenSize;
    return width && width <= 1440 ? '60px' : cardHeight;
  }, [screenSize, cardHeight]);

  return (
    <>
      <Card sx={{ position: 'relative', overflow: 'visible' }} elevation={0}>
        <CardContent
          className={`${location}-attachment-skeleton`}
          sx={{
            display: 'flex',
            height: dynamicCardHeight,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: abyssColors.primary[100],
            padding: '0 !important', // Remove default padding
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Skeleton
              animation="wave"
              variant="rectangular"
              width="100%"
              height="100%"
              sx={{ borderRadius: '4px', backgroundColor: 'transparent' }}
            />
          </Box>
        </CardContent>
      </Card>
      <Box sx={{ mt: 1 }}>
        <Skeleton
          animation="wave"
          variant="text"
          width="80%"
          height="24px"
          sx={{ borderRadius: '4px', backgroundColor: 'transparent' }}
        />
      </Box>
    </>
  );
};
